import { Row } from 'common/types/scalarSpreadsheet';
import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_CLASSNAME,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_NAME,
} from 'pages/FundInvestments/common/constants';
import { getStringValue } from 'utilities';
import { CreateCalculationRowParams } from './createCalculationRow.types';

const createCalculationRow = (params: CreateCalculationRowParams): Row => {
  const { alias, isSubtitle = false } = params;

  const classNameIdentifier = getStringValue(alias.split('__').pop()).toLocaleLowerCase();

  return {
    alias,
    className: `${FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_NAME}__${classNameIdentifier} ${
      isSubtitle ? 'subtitle-bold' : ''
    } ${FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_CLASSNAME}`,
    format: null,
    gridType: 'string',
    hidden: true,
    readOnly: true,
    value: '',
  } as Row;
};

export default createCalculationRow;
